<template>
<!-- 3张图样式（文字占田字1格） -->
  <div
    id="threePicAvg"
    class="threePicAvg"
    v-bind:style="{backgroundImage:'url(' +'\''+ backgroundPic +'\''+ ')', backgroundRepeat:'no-repeat'}"
  >
  <div class="pic-group">
    <div  class="left child-pic" >
          <img @click="goLink(tbInfo.link1)" :src="tbInfo.image1"  class="pic" :class="tbInfo.link1?'link':''"/>
    </div>
    <div  class=" child-text">
      <div class="title">{{tbInfo.title}}</div>
      <div class="content">{{tbInfo.content}}</div>
    </div>
  </div>
   <div class="pic-group">
    <div  class="left child-pic" 
    >
          <img @click="goLink(tbInfo.link2)" :src="tbInfo.image2"  class="pic" :class="tbInfo.link2?'link':''"/>
    </div>
    <div  class="right child-pic" 
    >
          <img @click="goLink(tbInfo.link3)" :src="tbInfo.image3"  class="pic" :class="tbInfo.link3?'link':''"/>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "threePicAvg",
  data() {
    return {
      loading: false
    };
  },
  props: ["tbInfo","backgroundPic"],
  methods: {
    // 跳转链接
    goLink(link){
      if(link){
         window.open(link)
      }
    }
  },
  computed: {
  },
  mounted() {
    
  }
};
</script>

<style scoped>
.threePicAvg {
  width: auto;
  height: 100%;
  background-position: center;
  background-size: cover;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 80px;
}
.child-text{
  flex:1;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: left;
}

.child-text .title{
  font-size: 26px;
  font-weight: 700;
  color: #222;
  text-align: left;
}

.child-text .sub-title{
  font-size: 18px;  
  /* white-space: pre; */
  word-break: break-all;
  margin-top: 10px;
  color: #222;
}

.child-text .content{
  font-size:18px;
  word-break: break-all;
  margin-top: 8px;
  color: #222;
  white-space: pre-wrap;
}
.pic-group {
  width: 100%;
  height: 242px;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  margin-top: 10px;
  box-sizing: border-box;
}
.threePicAvg .child-pic{
  flex:1;
  height: 100%;
  display: flex;
}
.threePicAvg .left{
  justify-content: left;
}
.threePicAvg .right{
  justify-content: right;
}
.threePicAvg .child-pic img{
  width: 442px;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
}

.threePicAvg .child-pic .link{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/tbChildPage/threePicAvg.vue